import { type FC, useState } from 'react'
import classNames from 'classnames'
import { type BusinessFinderProps } from './BusinessFinder.interface'
import { Button } from '../Button/Button'
import styles from './BusinessFinder.module.scss'
import { Icon } from '../Icon/Icon'
import { Tag } from '../Tag/Tag'

interface ExtendedBusinessFinderProps extends BusinessFinderProps {
  extraStyles?: {
    list?: string;
  };
}

export const BusinessFinder: FC<ExtendedBusinessFinderProps> = ({
  typeTitle,
  categoryTitle,
  businessTypes,
  showCategory,
  searchButton,
  extraStyles
}) => {
  const [activeBusinessType, setActiveBusinessType] = useState<number | undefined>(undefined)
  const [activeCategories, setActiveCategories] = useState<string[]>([])

  const setType = (index: number): void => {
    setActiveBusinessType(activeBusinessType === index ? undefined : index)
    setActiveCategories([])
  }

  const addCategory = (category: string): void => {
    if (activeCategories.includes(category)) {
      setActiveCategories(activeCategories.filter((item) => item !== category))
    } else if (activeCategories.length < 3 && !activeCategories.includes(category)) {
      setActiveCategories([...activeCategories, category])
    }
  }

  const submitSearch = (): void => {
    const searchParams = new URLSearchParams()
    if (activeCategories.length > 0) {
      searchParams.set('categories', activeCategories.join(','))
    }
    const paramsString = Array.from(searchParams.entries())
      .map(([key, value]) => `${key}=${value}`)
      .join(',')

    if (activeBusinessType !== undefined) {
      const separator = paramsString ? '?' : ''
      window.location.href = `/businesses/${businessTypes[activeBusinessType].value}${separator}${paramsString}`
    }
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{typeTitle}</h2>
      <ul className={styles.list}>
        {businessTypes.map((businessType, index) => (
          <li key={businessType.value}>
            <Tag
              value={businessType.value}
              active={activeBusinessType === index}
              type="button"
              onClick={() => { setType(index) }}
            >
              {businessType.label}
            </Tag>
          </li>
        ))}
      </ul>
      {activeBusinessType !== undefined && (
        <>
          {showCategory && (
            <>
              <h2 className={styles.title}>{categoryTitle}</h2>
              <ul className={classNames(styles.list, extraStyles?.list)}>
                {businessTypes[activeBusinessType].categories?.map((category) => (
                  <li key={category.value}>
                    <Tag
                      value={category.value}
                      active={activeCategories.includes(category.value)}
                      medium
                      type="button"
                      onClick={() => { addCategory(category.value) }}
                    >
                      {category.label}
                    </Tag>
                  </li>
                ))}
              </ul>
            </>
          )}
          <Button type="submit" round onClick={() => { submitSearch() }}>
            {searchButton}
            <Icon name="#search" className={styles.icon} />
          </Button>
        </>
      )}
    </div>
  )
}
